<script lang="ts">
	import type { Cache } from "$lib/serv/core/cache";
	import type { RxWritable } from "$lib/util/obs";
	import type { Item, Menu } from "proto/menu";
	import type { Page } from "@sveltejs/kit";
	import type { Observable } from "rxjs";

	import { findRealItem, retypeItem } from "$lib/ui/home/food/menu/Restaurant.svelte";
	
	import Grid from "$lib/ui/layout/Grid.svelte";
	import ItemTile from "$lib/ui/home/shop/ItemTile.svelte";
    import { query } from "$lib/util/url";

	export let cache: Cache<Menu>;
	// export let search$: Observable<string>;
	export let getItemLink: (item: ReturnType<typeof findRealItem>) => string;
	export let page: Page;

	$: items = cache.payload?.sections.map(({items}) => items).flat() ?? [];
</script>


{#if items.length === 0}
	<div style="margin-top: 3rem;">
		<p class="body-m book medium-importance text-center">No items to show. Try searching something else</p>
	</div>
{:else}
	<div id="search-info">
		<h3 class="headline-m bold">{`${items.length} results`}</h3>
		<!-- TODO: Add clear link -->
		<button class="button secondary label-s" on:click={() => query(page.url).remove('search').go()}>Clear search</button>
	</div>

	<Grid type="aisle" cache={{ loading: cache.loading, payload: items }} let:item={_item}>
		{@const item = retypeItem(_item)}
		{@const realItem = findRealItem(item, cache.payload) ?? item}
		<a class="item swimlane-menu-item" href={getItemLink(realItem)} data-sveltekit-noscroll>
			<ItemTile item={retypeItem(_item)} />
		</a>
	</Grid>
{/if}
